<template>
  <fragment>
    <slot />
  </fragment>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import featureLoaderMixin from "../../mixins/featureLoaderMixin";

export default {
  name: "ScriptLoaderVideo",
  mixins: [featureLoaderMixin],
  props: {
    toggleKey: {
      type: String,
      required: true,
    },
    options: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {
    ...mapGetters({
      getGlobalToggles: "getGlobalToggles",
    }),
  },
  mounted() {
    this.$slots.default[0].elm.addEventListener("click", () => {
      this.showFeatureOrConsent(this.options);
    });
  },
  methods: {
    ...mapActions({
      setGlobalToggle: "setGlobalToggle",
    }),
    loadFeature() {
      this.setGlobalToggle({ key: this.toggleKey, value: true });
    },
  },
};
</script>
